import React, {useState} from "react";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography} from "@mui/material";
import ShowSnackbar from "../utils/ShowSnackbar";
import {CustomBackdrop} from "../utils/customStyles";
import {ApiUrl} from "../utils/portal-urls";
import {handleHttpResponse} from "../utils/http-helpers";


const paperPropsStyle = {
    minWidth: '400px',
    minHeight: '200px',
    borderRadius: '12px'
}



export default function OrganizationUserDeleteDialog(props) {

    const userDeleteDialogOpen = props.userDeleteDialogOpen;
    const setUserDeleteDialogOpen = props.setUserDeleteDialogOpen;
    const user = props.user;
    const [loading, setLoading] = useState(false);
    const [snackbarMsg, setSnackbarMsg] = useState({open: false, msg: '', msgLv: ''});

    const handleClose = () => {
        setUserDeleteDialogOpen(false);
    };

    const handleRefresh = () => {
        props.setRefresh(new Date().getTime());
    }

    const handleSubmit = async (event) => {
        setLoading(true);
        event.preventDefault();
        const url = ApiUrl.Users.deleteUser.getPath(user.id);

        const requestOption = {
            method: 'DELETE',
            body: ''
        }

        setUserDeleteDialogOpen(false)

        try {
            const res = await fetch(url, requestOption);
            const data = await handleHttpResponse(res);
            console.info(data);
            handleRefresh();
            setSnackbarMsg({open: true, msg: 'Successfully delete User: ' + user.givenName, msgLv: 'success'});
        } catch (err) {
            console.error(`Failed to delete User: ${user.givenName}. ` + err);
            setSnackbarMsg({open: true, msg: `Failed to delete User: ${user.givenName}`, msgLv: 'error'});
        } finally {
            setLoading(false);
        }
    }


    return (
        <div>
            <Dialog
                open={userDeleteDialogOpen}
                onClose={handleClose}
                PaperProps={{ style: paperPropsStyle}}
            >
                <DialogTitle color="white"
                             sx={{backgroundColor: "rgba(60,120,185,1)"}}
                >
                    Confirm Delete
                </DialogTitle>
                <DialogContent>
                    <Typography fontWeight='bold' margin='12px 0px 12px 0px'>
                        {`Please confirm you wish to delete ${user.givenName} ${user.familyName}`}
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <div style={{ marginBottom: '10px', marginRight: '10px', display: 'flex', gap: '10px'}}>
                        <Button type='submit' onClick={handleSubmit} variant='contained'>
                            Delete
                        </Button>
                        <Button onClick={handleClose} autoFocus variant='outlined'>Cancel</Button>
                    </div>
                </DialogActions>
            </Dialog>
            <ShowSnackbar open={snackbarMsg.open} close={(c) => setSnackbarMsg(c)} msg={snackbarMsg} />
            <CustomBackdrop open={loading} />
        </div>
    )
}
